import dayjs from 'dayjs';
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath';

const RecoReceiveLetter = ({ printOutPdfDetails, printRef,onRenderReady }: any) => {
    const formatDate = (date: Date | string) => {
        return dayjs(date).format("MMM D, YYYY").toUpperCase();
    };
    const formattedDate = formatDate(new Date());
    useEffect(() => {
        if (printOutPdfDetails) {
            onRenderReady?.();
        }
    }, [printOutPdfDetails]);
    return (
        <div className='row p-5' ref={printRef} style={{ pageBreakAfter: "always" }}>
            <div className='d-flex justify-content-center align-items-center'>
                <ImageWithBasePath
                    src="assets/img/logo.svg"
                    className=""
                    alt="Logo"
                    width={300}
                    height={68}
                />
            </div>
            <div className='text-end'>
                {formattedDate}
            </div>
            <div>
                <p className='mb-0'>
                    {printOutPdfDetails?.primaryContactFirstName} {printOutPdfDetails?.primaryContactLastName}
                </p>
                <p className='mb-0'>
                    {printOutPdfDetails?.secondaryContactFirstName} {printOutPdfDetails?.secondaryContactLastName}
                </p>
                <p className='mb-0'>
                    {printOutPdfDetails?.mailingAddressLine1}
                </p>
                <p className='mb-0'>
                    {printOutPdfDetails?.mailingAddressLine2}
                </p>
                <p className='mb-0'>
                    {printOutPdfDetails?.mailingCity} {" "} {printOutPdfDetails?.mailingState ? ',' : ''} {" "} {printOutPdfDetails?.mailingState} {" "}  {printOutPdfDetails?.mailingZipCode}
                </p>
            </div>
            <div className='mt-3'>
                Dear {printOutPdfDetails?.primaryContactFirstName} {printOutPdfDetails?.secondaryContactFirstName ? '&' : ''} {printOutPdfDetails?.secondaryContactFirstName} :

            </div>
            <p className='mt-2'>
                Thank you for recently referring Airoom to {`<`}Referred Client's Name{`>`}.  We have received your recommendation form concerning this client and are eagerly working with them.  If this client decides to build with Airoom, we will forward a check for $750.00.            </p>
            <p>
                Thank you again for your kind words and helpful referral.  We look forward to seeing your name on several referral checks so please keep us in mind should anyone ask.
            </p>
            <p>
                In the meantime, I hope you are enjoying your project and if there is anything that we can do for you, please feel free to give me a call.
            </p>
            <p>
                Sincerely,

            </p>
            <p className='mt-3 mb-0'>
                Thomas D. Graham
            </p>
            <p>
                Senior Vice President
            </p>
            <p>
                TDG/lac
            </p>
            <div className='d-flex justify-content-center align-items-center mt-5' style={{ opacity: 0.1 }}>
                <ImageWithBasePath
                    src="assets/img/logo-small.svg"
                    className=""
                    alt="Logo"
                    width={150}
                    height={68}

                />
            </div>
            <div className='text-center mt-3'>
                <p className='mb-0'>
                    <b>
                        CORPORATE OFFICES AND DESIGN CENTER {" "}
                    </b>
                    6825 N. Lincoln Ave., Lincolnwood, IL 60712 <b> BRANCH OFFICE</b> Hinsdale, IL
                </p>
                <p>
                    <b>AIROOM INC.</b> - 847.967.ROOM - 847.763.1101 (fax) - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                </p>
            </div>
        </div>
    )
}

export default RecoReceiveLetter